module.exports = __webpack_public_path__ + "static/nyoutritious-2-25e80e315be2a9dc76ca936c1655b70e.jpeg";